var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "NEW_ZEALAND_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7948 0.824219V1.44722V1.66022V1.76021L13.0688 3.62122H16.7948V4.18222V5.02121V5.86021V6.41922H13.0688L16.7948 8.28221V8.59521V9.21921V9.27321H15.6478H15.2198H15.0218L9.79582 6.65822V9.27321H9.23482H8.39583H7.55882H6.99782V6.65822L1.77184 9.27321H1.14583H0.00683594V20.4022H33.5688V0.824219H16.7948Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.00683594 6.41895V8.27794L3.72484 6.41895H0.00683594Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.7959 0.824219V3.38521L14.9119 0.824219H9.7959Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.9978 0.824219H1.88281L6.9978 3.38521V0.824219Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M0.00683594 3.62163H3.72484L0.00683594 1.76562V3.62163Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.7874 0.824219L11.1934 3.62122H9.9404L15.5344 0.824219H14.9114L9.79538 3.38521V0.824219H9.23438V3.66321V3.97621V4.18222H10.0734H11.3254H11.7534H11.9494H16.7944V3.62122H13.0684L16.7944 1.76021V1.66022V1.44722V0.824219H16.7874Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.99782 0.824219V3.38521L1.88283 0.824219H0.00683594L5.60085 3.62122H4.34984L0.00683594 1.45221V1.76521L3.72484 3.62122H0.00683594V4.18222H4.84184H5.46883H6.71782H7.55882V3.97621V3.76321V3.66321V0.824219H6.99782Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.3254 5.86035H10.0734H9.23438V6.06535V6.27936V6.37836V9.27335H9.79538V6.65836L15.0214 9.27335H15.2194H15.6474H16.7944V9.21935L11.1934 6.41936H12.4434L16.7944 8.59535V8.28235L13.0684 6.41936H16.7944V5.86035H11.9494H11.3254Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M6.71782 5.86035H5.46883H5.03984H4.84184H0.00683594V6.41936H3.72484L0.00683594 8.27835V9.21535L5.60085 6.41936H6.85085L1.14583 9.27335H1.77184L6.99782 6.65836V9.27335H7.55882V6.37836V6.06535V5.86035H6.71782Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M5.60085 6.41895L0.00683594 9.21494V9.27293H1.14583L6.85085 6.41895H5.60085Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M0.00683594 1.45221L4.34984 3.62122H5.60085L0.00683594 0.824219V1.45221Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M16.7874 0.824219H15.5344L9.94043 3.62122H11.1934L16.7874 0.824219Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M11.1934 6.41895L16.7944 9.21893V8.59494L12.4434 6.41895H11.1934Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M7.55882 0.824219V3.66321V3.76321V3.97621V4.18222H6.71782H5.46883H4.84184H0.00683594V5.86021H4.84184H5.03984H5.46883H6.71782H7.55882V6.06522V6.37822V9.27321H8.39583H9.23482V6.37822V6.27922V6.06522V5.86021H10.0738H11.3258H11.9498H16.7948V5.02121V4.18222H11.9498H11.7538H11.3258H10.0738H9.23482V3.97621V3.66321V0.824219H7.55882Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M23.3047 6.53789H24.2147L24.4987 5.6709L24.7797 6.53789H25.6887L24.9537 7.07489L25.2337 7.94189L24.4987 7.40489L23.7577 7.94189L24.0417 7.07489L23.3047 6.53789Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M23.709 6.67163H24.31L24.499 6.09863L24.684 6.67163H25.285L24.8 7.02562L24.984 7.60063L24.499 7.24562L24.01 7.60063L24.196 7.02562L23.709 6.67163Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M19.6543 10.2098H20.5653L20.8503 9.34082L21.1313 10.2098H22.0433L21.3073 10.7438L21.5863 11.6118L20.8503 11.0758L20.1133 11.6118L20.3943 10.7438L19.6543 10.2098Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M20.0596 10.3416H20.6616L20.8496 9.76758L21.0346 10.3416H21.6406L21.1506 10.6956L21.3376 11.2706L20.8496 10.9136L20.3596 11.2706L20.5486 10.6956L20.0596 10.3416Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M26.5605 9.30035H27.3735L27.6255 8.52734L27.8755 9.30035H28.6845L28.0295 9.77335L28.2816 10.5473L27.6255 10.0714L26.9675 10.5473L27.2195 9.77335L26.5605 9.30035Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M26.9219 9.41628H27.4609L27.6259 8.90527L27.7909 9.41628H28.3289L27.8939 9.73227L28.0589 10.2423L27.6259 9.92728L27.1899 10.2423L27.3569 9.73227L26.9219 9.41628Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M23.1719 15.9689H24.1839L24.4989 15.0049L24.8099 15.9689H25.8239L25.0049 16.5649L25.3159 17.5289L24.4989 16.9339L23.6799 17.5289L23.9909 16.5649L23.1719 15.9689Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_84621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119101107672756785540000007391193625288389508__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M33.5698 0.824219H0.00683594V20.4022H33.5698V0.824219Z",
    fill: "white"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_84621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M23.6211 16.1165H24.2911L24.4991 15.4795L24.7051 16.1165H25.3741L24.8341 16.5105L25.0411 17.1495L24.4991 16.7545L23.9571 17.1495L24.1651 16.5105L23.6211 16.1165Z",
    fill: "#BD0034"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/NEW_ZEALAND.1387102b9939901f2ef14725655c92b2.svg";
export { ForwardRef as ReactComponent };